/**
 * Null-safe localStorage helpers.
 * Returns null / false when localStorage is unavailable (privacy mode, restricted webviews).
 * Never throws.
 */

export const safeStorageGet = (key: string): string | null => {
  try {
    return window.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

export const safeStorageSet = (key: string, value: string): boolean => {
  try {
    if (!window.localStorage) return false;
    window.localStorage.setItem(key, value);

    return true;
  } catch {
    return false;
  }
};
